'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var styledComponents = require('./styled-components.js');
var TabPanel = require('../components/TabPanel/TabPanel.js');

var a11yProps = function (uniqueId, index) {
    return {
        id: uniqueId + "-tab-" + index,
        'aria-controls': uniqueId + "-tabpanel-" + index,
    };
};
var VerticalTabMenu = function (props) {
    var menuItems = props.menuItems, uniqueId = props.uniqueId, _a = props.hideTabs, hideTabs = _a === void 0 ? false : _a, _b = props.initialTab, initialTab = _b === void 0 ? 0 : _b, PreTabElement = props.PreTabElement, PostTabElement = props.PostTabElement, _c = props.width, width = _c === void 0 ? '270px' : _c, _d = props.resetTabSelection, resetTabSelection = _d === void 0 ? false : _d;
    var _e = React.useState(initialTab), value = _e[0], setValue = _e[1];
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    React.useEffect(function () {
        if (!resetTabSelection) {
            return;
        }
        setValue(initialTab);
    }, [resetTabSelection]);
    return (React__default.createElement(styledComponents.FlexDiv, null,
        !hideTabs && (React__default.createElement(styledComponents.MainDiv, { width: width },
            PreTabElement,
            React__default.createElement(styledComponents.StyledTabs, { orientation: 'vertical', variant: 'standard', value: value, onChange: handleChange, "aria-label": uniqueId, width: width }, menuItems.map(function (menuItem, index) { return (React__default.createElement(styledComponents.StyledTab, tslib.__assign({ key: typeof menuItem.text === 'string' ? menuItem.text : menuItem.key || index, label: menuItem.text }, a11yProps(uniqueId, index)))); })),
            PostTabElement)),
        menuItems.map(function (menuItem, index) { return (React__default.createElement(TabPanel, { key: typeof menuItem.text === 'string' ? menuItem.text : menuItem.key || index, value: value, index: index }, menuItem.component)); })));
};

module.exports = VerticalTabMenu;
